enum AgentTaskState {
  COMPLETED = 'completed',
  FAILED = 'failed',
  PAUSED = 'paused',
  PENDING = 'pending',
  RUNNING = 'running',
  WAITING_FOR_ONCALL_TO_ANSWER = 'waiting_for_oncall_to_answer',
  WAITING_FOR_USER_TO_ANSWER = 'waiting_for_user_to_answer',
}

enum BrowserTaskLogStatus {
  BROWSER_AGENT_ONCALL_REVIEW_REQUESTED = 'browser_agent_oncall_requested',
  BROWSER_AGENT_USER_REVIEW_REQUESTED = 'browser_agent_user_requested',
  TASK_COMPLETED = 'task_completed',
  TASK_FAILED = 'task_failed',
  TASK_INITIATED = 'task_initiated',
  TASK_RESUMED = 'task_resumed',
}

enum ExecutorRole {
  AI = 'ai',
  CUSTOMER = 'customer',
  TEAM_MEMBER = 'team_member',
}

type AgentTask = {
  browser_run_state: AgentTaskState;
  job_context_id: string;
  task_id: string;
  task_payload: string;
  user_id: string;
  workflow_id: string;
  workflow_run_id: string;
};

type BrowserRunLogRecord = {
  executor_role: ExecutorRole;
  record_id: string;
  record_payload: any;
  record_status: BrowserTaskLogStatus;
  record_timestamp: string;
  record_level: string;
};

type BrowserTask = {
  automation_path: string;
  browser_run_state: AgentTaskState;
  business_line: string;
  carrier_name: string;
  task_id: string;
  task_log: BrowserRunLogRecord[];
  task_result: any;
  user_id: string;
  workflow_run_id: string;
};

type BrowserRun = {
  browser_run_context: Record<string, any>;
  browser_run_id: string;
  browser_run_log: BrowserRunLogRecord[];
  browser_run_state: AgentTaskState;
  browser_workflow_id: string;
  business_line: string;
  carrier_name: string;
  user_id: string;
};

type AutomationJob = {
  job_args: {
    [key: string]: any;
    url: string;
  };
  job_type: string;
};

type AutomationPage = {
  [key: string]: any;
  is_last_page: boolean;
  on_failure?: {
    [key: string]: any;
    classify_as: string;
  };
  page_classifier: {
    exclude_selectors: string[];
    unique_selectors: string[];
  };
  page_context: {
    [key: string]: any;
    extraction: string;
    observe: string;
  };
  skip_observe_and_extract?: boolean;
  use_scroll_type_0?: boolean;
};

type AutomationWorkflow = {
  agent_workflow_id: string;
  browser_state_name: string;
  global_context: {
    [key: string]: any;
    carrier_name: string;
  };
  initial_jobs: AutomationJob[];
  pages: Record<string, AutomationPage>;
};

enum ConnectionStatus {
  CHECKING = 'checking',
  CONNECTED = 'connected',
  LOGIN_ERROR = 'login_error',
  NOT_CONNECTED = 'not_connected'
}

export type {
  AgentTask,
  BrowserRunLogRecord,
  BrowserTask,
  BrowserRun,
  AutomationWorkflow,
  AutomationJob,
  AutomationPage,
};

export { AgentTaskState, ExecutorRole, BrowserTaskLogStatus, ConnectionStatus };
